import { Channel } from '@/libraries/channel.ts';

const channel = Channel.getInstance('ally');

export default {
	login({}) {
		channel.emit({
			command: 'login',
			to: 'background',
		});
	},
	logout({}) {
		channel.emit({
			command: 'logout',
			to: 'background',
		});
	},
	async isLoggedIn({ commit }: any) {
		const isAuthed = await channel.emit({
				command: 'isLoggedIn',
				to: 'background',
			});

		commit('SET_AUTH_STATE', isAuthed);
		return isAuthed;
	},
	async getUserInfo({ commit }: any) {
		const response: any = await channel.emit({
			command: 'getUserInfo',
			to: 'background',
		});
		if (response.firstName) {
			commit('SET_USER_INFO', response.firstName);
		} else {
			commit('SET_USER_INFO', response.email);
		}
		commit('SET_USER', response);
	},
};
